export enum CardFloatStyle {
    None = "none",
    Float = "float",
    Outline = "outline",
}
